import { render } from "./ListeArrondissement.vue?vue&type=template&id=2166ffc9&ts=true"
import script from "./ListeArrondissement.vue?vue&type=script&lang=ts"
export * from "./ListeArrondissement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__